<app-user-profile-view *ngIf="!editMode && user" [user]="user" (editEnabled)="enableEditMode()"></app-user-profile-view>
<app-user-profile-edit *ngIf="editMode  && user" [user]="user" [signUpMode]="signUpMode" (editProfileCompleted)="disableEditMode()"></app-user-profile-edit>
